import styled from "styled-components";

export const Container = styled.div`
  display: none;
  @media (min-width: 769px) {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    background: #262f56;
    height: 100%;
    padding: 10px;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid #eee;
  background: white;
  & > a {
    padding: 10px 10px;
    color: #373737;
    border-bottom: 1px solid #eee;
    border-radius: 0;
    display: flex;
    align-items: center;
    letter-spacing: 1px;
    width: 250px;
    & > *:first-child {
      margin-right: 10px;
    }
  }
  & > a:first-child {
    padding-top: 10px;
    border-radius: 10px 10px 0 0;
  }
  & > a:last-child {
    border-bottom: none;
    padding-bottom: 10px;
    border-radius: 0 0 10px 10px;
  }
  & > a:hover {
    font-weight: bold;
    /* border-bottom: 2px solid #ffa500; */
  }
  & > a.selected {
    font-weight: bold;
    /* border-bottom: 2px solid #ffa500; */
  }
  & > * {
    position: relative;
  }
`;

export const Brand = styled.div`
  height: 120px;
  & > img {
    width: auto;
    max-height: 50px;
  }
  @media (min-width: 769px) {
    display: flex;
    justify-content: center;
    & > img {
      width: auto;
      max-height: 55px;
    }
  }
`;

export const CtaBox = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 20px;
`;

export const Crown = styled.span`
  background: white;
  height: 100%;
  position: absolute;
  width: 100px;
  right: 0;
  border-radius: 0px 0px 10px 0px;
  display: flex;
  justify-content: flex-end;
  padding-right: 15px;
  align-items: center;
  overflow: hidden;
  & > span:first-child {
    position: absolute;
    width: 200px;
    height: 200px;
    left: 10px;
    background: orange;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(44deg);
    top: -133px;
  }
`;
